export default __webpack_public_path__ + "static/media/fama.18a0f7fa.svg";